import {CONFIG} from '@gallaghercp/core-frontend';

export const APP_CONFIG: CONFIG = {
  appName: 'Ardent Health Benefits',
  frontend: 'https://getardentbenefits.com',
  apiHash: 'https://getardentbenefits.com/api/1.0',
  api: '/api/2.0',
  modernised: true,
  authHeaders: {
    xServiceProvider: 'ardent-prod-frontend',
    'tenant-id': '83c37edc-22a6-42f8-be6c-1909be66aaea',
    'consumer-id': '715b0838-2008-4cbc-9b17-ab6acb402990',
  },
  commitSHA: '06af44c',
  provider: 'ardent-prod-frontend',
cookiePolicy: '087f8757',
cookiePolicyUsCompliance: true,
} as CONFIG;

